import React, { useState } from 'react'
import { View, Platform } from 'react-native'
import PropTypes from 'prop-types'
import RNModal from 'react-native-modal'
import { WebView } from '@vfgroup-oneplatform/framework/CommonUI'
import { check, request, PERMISSIONS, RESULTS, openSettings } from 'react-native-permissions'

import VfText from '../VfText'
import VFButton from '../VFButton'
import Modal from '../Modal'

import styles from './Browser.Styles'

function PermissionsModal(props) {
  const {
    isVisible,
    onClose,
    onOpenSettings,
    desc,
    buttonTitle,
    ...rest
  } = props

  return (
    <RNModal
      backdropOpacity={0.5}
      onSwipeComplete={onClose}
      onBackdropPress={onClose}
      swipeDirection={null}
      propagateSwipe
      hideModalContentWhileAnimating
      hardwareAccelerated
      useNativeDriver={true}
      animationIn="fadeIn"
      animationOut="fadeOut"
      coverScreen
      style={styles.modal}
      isVisible={isVisible}
      {...rest}
    >
      <View style={styles.permissionContainer}>
        <VfText size="h4" i18nKey={desc} />
        <VFButton
          type="tertiary"
          title={buttonTitle}
          onPress={onOpenSettings}
          disabled={false}
          style={styles.permissionButton}
        />
      </View>
    </RNModal>
  )
}
PermissionsModal.defaultProps = {
  desc: 'giga_location_permission',
  buttonTitle: 'giga_open_settings',
}
PermissionsModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onOpenSettings: PropTypes.func,
  desc: PropTypes.string,
  buttonTitle: PropTypes.string,
}

function Browser(props) {
  const {
    browserState,
    closeBrowser,
    onMessage,
  } = props

  const [isMnualPermission, setMnualPermission] = useState(false)

  const onMessageRecieved = event => {
    if (event.nativeEvent.data === 'requestLocation') {
      check(
        Platform.OS === 'android'
          ? PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION
          : PERMISSIONS.IOS.LOCATION_WHEN_IN_USE,
      )
        .then((result) => {
          switch (result) {
            case RESULTS.UNAVAILABLE:
              break
            case RESULTS.DENIED:
              request(PERMISSIONS.IOS.LOCATION_WHEN_IN_USE)
                .catch(() => { })
              break
            case RESULTS.GRANTED:
              break
            case RESULTS.BLOCKED:
              setMnualPermission(true)
              break
          }
        })
        .catch(() => { })
    }
    onMessage?.()
  }

  return (
    <Modal
      visible={browserState.isVisible}
      close={closeBrowser}
      backdropTransitionInTiming={0}
      backdropTransitionOutTiming={0}
      backdropOpacity={0}
      useNativeDriver={true}
      type="full"
      coverScreen
    >
      <WebView
        url={browserState.url}
        onClose={closeBrowser}
        onMessage={onMessageRecieved}
        geolocationEnabled={true}
        setSupportZoom={true}
        navigation
      />
      <PermissionsModal
        isVisible={isMnualPermission}
        onClose={() => setMnualPermission(false)}
        close={() => setMnualPermission(false)}
        onOpenSettings={() => {
          setMnualPermission(false)
          openSettings()
        }}
      />
    </Modal>
  )

}

Browser.propTypes = {
  browserState: PropTypes.objectOf({
    isVisible: PropTypes.bool,
    url: PropTypes.string,
  }),
  closeBrowser: PropTypes.func,
  onMessage: PropTypes.func,
}

Browser.defaultProps = {

}

export { PermissionsModal }
export default Browser
